import React, {useState, useEffect, useRef} from 'react'
import styles from './styles.module.scss'
import branchApi from "../../../../store/branchStore/branchApi";
import {Roles} from "../../../../config";
import ButtonFilled from "../../../../components/FormElements/ButtonFilled";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useCurrentBranch} from "../../../../hooks/useCurrentBranch";
import { store } from "react-notifications-component";
import {useHistory} from "react-router-dom";
import { format } from 'date-fns';
import TextField from "../../../../components/FormElements/TextField";
import ButtonOutlined from "../../../../components/FormElements/ButtonOutlined";
import {Badge} from "../../../../components/Badge";
import {API_URL} from "../../../../api";
import cookies from "react-cookies";
import {COOKIES} from "../../../../helpers";
import FailedNotificationLine from "../../../../components/FailedNotificationLine";

const XLSXNotifications = () => {
  const { info } = useSelector(s => s.branchReducer);
  const history = useHistory()
  const { t } = useTranslation();
  const [modalPending, setModalPending] = useState(false);
  const [pushMessage, setPushMessage] = useState('')
  const [bonus, setBonus] = useState('')
  const [file, setFile] = useState(null)
  const [disableAutonotificationStatus, setDisableAutonotificationStatus] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [historyOfNotifications, setHistoryOfNotifications] = useState([])
  const { currentRole, currentBranch, groupId } = useCurrentBranch();
  const [branchIds, setBranchIds] = useState([]);
  const fileInputRef = useRef(null)

  const XLSIcon = (
    <svg style={{ flexShrink: 0 }} width="30" height="30" viewBox="0 0 30 30" fill="none">
      <path d="M18.2888 24.375C18.2888 24.6236 18.19 24.8621 18.0142 25.0379C17.8384 25.2137 17.5999 25.3125 17.3513 25.3125H14.07C13.8214 25.3125 13.583 25.2137 13.4071 25.0379C13.2313 24.8621 13.1325 24.6236 13.1325 24.375V17.8125C13.1325 17.5639 13.2313 17.3254 13.4071 17.1496C13.583 16.9738 13.8214 16.875 14.07 16.875C14.3187 16.875 14.5571 16.9738 14.733 17.1496C14.9088 17.3254 15.0075 17.5639 15.0075 17.8125V23.4375H17.3513C17.5999 23.4375 17.8384 23.5363 18.0142 23.7121C18.19 23.8879 18.2888 24.1264 18.2888 24.375ZM10.865 17.0496C10.7648 16.978 10.6515 16.9269 10.5315 16.8991C10.4116 16.8714 10.2874 16.8675 10.1659 16.8877C10.0445 16.908 9.92821 16.9519 9.82376 17.0171C9.71931 17.0823 9.62872 17.1674 9.55716 17.2676L7.9763 19.4813L6.39544 17.2676C6.32643 17.1614 6.23662 17.0703 6.13144 16.9998C6.02625 16.9293 5.90787 16.8808 5.78343 16.8573C5.659 16.8338 5.53109 16.8357 5.40742 16.863C5.28376 16.8903 5.1669 16.9423 5.06391 17.016C4.96091 17.0897 4.87391 17.1835 4.80816 17.2917C4.7424 17.3999 4.69926 17.5203 4.68132 17.6457C4.66339 17.7711 4.67104 17.8988 4.70381 18.0211C4.73658 18.1434 4.7938 18.2578 4.872 18.3574L6.82435 21.0938L4.86966 23.8301C4.73811 24.0325 4.68971 24.2778 4.73452 24.515C4.77934 24.7522 4.91393 24.963 5.11026 25.1034C5.30659 25.2439 5.54953 25.3032 5.78849 25.269C6.02745 25.2348 6.24402 25.1098 6.3931 24.9199L7.9763 22.7062L9.55716 24.9199C9.70623 25.1098 9.9228 25.2348 10.1618 25.269C10.4007 25.3032 10.6437 25.2439 10.84 25.1034C11.0363 24.963 11.1709 24.7522 11.2157 24.515C11.2606 24.2778 11.2121 24.0325 11.0806 23.8301L9.12825 21.0938L11.0829 18.3574C11.1545 18.2572 11.2056 18.1439 11.2334 18.024C11.2612 17.9041 11.2651 17.7798 11.2448 17.6584C11.2246 17.5369 11.1806 17.4207 11.1154 17.3162C11.0503 17.2118 10.9652 17.1212 10.865 17.0496ZM22.4595 20.0754C21.9908 19.9395 21.5056 19.8 21.2349 19.6254C21.0884 19.5293 21.0908 19.5082 21.1036 19.4027C21.1054 19.3175 21.1276 19.234 21.1684 19.1591C21.2092 19.0843 21.2674 19.0203 21.338 18.9727C21.8771 18.607 23.1357 18.7711 23.6607 18.907C23.9012 18.9703 24.1571 18.9354 24.3719 18.81C24.5867 18.6846 24.7429 18.479 24.8062 18.2385C24.8694 17.9979 24.8345 17.7421 24.7091 17.5273C24.5838 17.3124 24.3782 17.1562 24.1376 17.093C23.8904 17.0285 21.6767 16.4812 20.2904 17.4164C19.998 17.6139 19.7526 17.8732 19.5714 18.1759C19.3902 18.4786 19.2776 18.8174 19.2415 19.1684C19.0072 21.0293 20.8411 21.5602 21.9368 21.8766C23.3501 22.2855 23.4743 22.4531 23.4345 22.766C23.3982 23.0484 23.2868 23.1562 23.1825 23.2266C22.6435 23.5852 21.406 23.4082 20.8927 23.2676C20.6526 23.2009 20.3959 23.2324 20.179 23.355C20.0716 23.4157 19.9772 23.497 19.9012 23.5942C19.8252 23.6914 19.7691 23.8026 19.7361 23.9215C19.7031 24.0404 19.6938 24.1646 19.7088 24.2871C19.7238 24.4095 19.7627 24.5278 19.8235 24.6352C19.9461 24.8521 20.1499 25.0115 20.39 25.0781C20.971 25.2312 21.5692 25.31 22.17 25.3125C22.8521 25.3125 23.6115 25.1953 24.2197 24.7898C24.5197 24.5903 24.7718 24.3268 24.9578 24.0182C25.1438 23.7096 25.2591 23.3636 25.2954 23.0051C25.5544 20.9766 23.6185 20.4105 22.4595 20.0754ZM4.69505 13.125V4.6875C4.69505 4.19022 4.89259 3.71331 5.24422 3.36167C5.59585 3.01004 6.07277 2.8125 6.57005 2.8125H17.82C17.9432 2.8124 18.0652 2.83657 18.179 2.88362C18.2928 2.93067 18.3962 2.99969 18.4833 3.08672L25.0458 9.64922C25.1329 9.73635 25.2019 9.83977 25.2489 9.95358C25.296 10.0674 25.3201 10.1893 25.32 10.3125V13.125C25.32 13.3736 25.2213 13.6121 25.0455 13.7879C24.8696 13.9637 24.6312 14.0625 24.3825 14.0625C24.1339 14.0625 23.8955 13.9637 23.7196 13.7879C23.5438 13.6121 23.445 13.3736 23.445 13.125V11.25H17.82C17.5714 11.25 17.333 11.1512 17.1571 10.9754C16.9813 10.7996 16.8825 10.5611 16.8825 10.3125V4.6875H6.57005V13.125C6.57005 13.3736 6.47128 13.6121 6.29546 13.7879C6.11965 13.9637 5.88119 14.0625 5.63255 14.0625C5.38391 14.0625 5.14545 13.9637 4.96964 13.7879C4.79382 13.6121 4.69505 13.3736 4.69505 13.125ZM18.7575 9.375H22.1185L18.7575 6.01289V9.375Z" fill="#6C6D6C"/>
    </svg>
  )

  const handleButtonClick = () => {
    fileInputRef.current?.click(); // триггерим клик на input
  };

  const onChangePushMessage = (e) => {
    if (e.target.value.length <= 1200) {
      setPushMessage(e.target.value);
    }
  }

  const onDisableAutoNotification = () => {
    if (!info) return

    setDisableAutonotificationStatus(true);
    branchApi.branchesCustomersUploadedStop(info.group_id, {
      branch_ids: branchIds.length ? branchIds : historyOfNotifications.map(({ branch_id }) => String(branch_id))
    })
      .then((res) => {
        store.addNotification({
          title: t('success'),
          message: 'Рассылка успешно остановлена',
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true
          }
        });
      })
      .finally(() => {
        setDisableAutonotificationStatus(false);
      });
  }

  const onSendPushToCustomers = () => {
    if (!info || !pushMessage) return

    setModalPending(true);

    const formData = new FormData();

    formData.set('file', file)
    formData.set('message', pushMessage)
    if (bonus) {
      formData.set('bonus', bonus)
    }

    branchApi.branchesNotificationsXLSXSend(info?.id, formData)
      .then((res) => {
        store.addNotification({
          title: t('success'),
          message: t('successMessageSent'),
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true
          }
        });
        setPushMessage('');
        setFile(null);
        setBonus('');
      })
      .finally(() => {
        setModalPending(false);
      });
  }

  useEffect(() => {
    let intervalId = null
    if (info?.group_id) {
      branchApi.branchesCustomersUploadedHistory(info.group_id)
        .then((response) => {
          const data = response?.data || [];
          setHistoryOfNotifications(data)

          // Extract branch IDs for the stop notification functionality
          if (data.length > 0) {
            const ids = data.map(item => String(item.branch_id));
            setBranchIds(ids);
          }
        })

      intervalId = setInterval(() => {
        branchApi.branchesCustomersUploadedHistory(info.group_id)
          .then((response) => {
            const data = response?.data || [];
            setHistoryOfNotifications(data)

            if (data.length > 0) {
              const ids = data.map(item => String(item.branch_id));
              setBranchIds(ids);
            }
          })
      }, 10000)
    }

    return () => {
      intervalId && clearInterval(intervalId)
    }
  }, [info?.group_id]);

  const handleDownloadTemplate = () => {
    setDownloading(true)
    fetch(`${API_URL}/branches/${info?.id}/tags/customers/bulk/template`, {
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/vnd.ms-excel;charset=UTF-8',
        Authorization: `Bearer ${cookies.load(COOKIES.TOKEN)}`
      },
      method: 'GET'
    }).then((response) => {
      response.blob().then((blob) => {
        const filename = decodeURI(response.headers.get('Content-Disposition')?.split('filename=')[1] || '')
        if ('msSaveOrOpenBlob' in window.navigator) {
          navigator.msSaveBlob(blob, filename)
        } else {
          const a = document.createElement('a')
          document.body.appendChild(a)
          a.href = window.URL.createObjectURL(blob)
          a.download = filename
          a.target = '_blank'
          a.click()
          a.remove()
        }
      })
        .finally(() => {
          setDownloading(false)
        });

      return {};
    })
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      <div className={styles.container}>
        <div className={styles.leftContent}>
          <div className={styles.modalContainer}>
            <div style={{ marginBottom: 16, display: 'flex', gap: 16, alignItems: 'center' }}>
              <ButtonOutlined onClick={handleButtonClick} variant="green" style={{ width: 192, }}>
                <input
                  type="file"
                  accept=".xlsx,.xls"
                  // multiple
                  onChange={(e) => {
                    const file = e.target.files[0];
                    setFile(file)
                  }}
                  ref={fileInputRef}
                  hidden
                />
                {t('importFile')}
              </ButtonOutlined>
              {file?.name ? (
                <Badge style={{ flexShrink: 1 }} onDelete={() => setFile(null)}>
                  {XLSIcon}
                  <span style={{ color: '#6C6D6C', fontSize: 18, overflowWrap: 'anywhere' }}>{file.name}</span>
                </Badge>
              ) : null}
            </div>

            <div>
              <textarea
                placeholder={t('NSMailing.textMailing')}
                className={styles.textArea}
                value={pushMessage}
                onChange={onChangePushMessage}
                required
              />
              <div className={styles.span}
                   style={{color: `${pushMessage.length >= 624 ? 'tomato' : '#000000'}`}}>
                {t('maxSym', {sym: 1200 })}
              </div>

              <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
                <p style={{ margin: 0 }}>{t('NSTag.giftBonusCount')}:</p>
                <TextField
                  width={100}
                  type="number"
                  value={bonus}
                  onChange={(e) => setBonus(e.target.value)}
                  required
                />
              </div>

              <div style={{display: 'flex', gap: 8, flexDirection: 'column', marginTop: '16px'}}>
                <ButtonFilled
                  className={styles.stopBtn}
                  onClick={onDisableAutoNotification}
                  loading={modalPending || disableAutonotificationStatus}
                >
                  Прервать предыдущую авторассылку
                </ButtonFilled>
                <ButtonFilled
                  className={styles.btn}
                  onClick={onSendPushToCustomers}
                  disabled={!info?.id || !pushMessage || !file}
                  loading={modalPending || disableAutonotificationStatus}
                >
                  {t('send')}
                </ButtonFilled>
                {/* <ButtonFilled
                  type="button"
                  className={styles.btn}
                  style={{ width: 300 }}
                  onClick={handleDownloadTemplate}
                  loading={downloading}
                >
                  {t('uploadTemplate')}
                </ButtonFilled> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.historyOfNotifications}>
        {historyOfNotifications && historyOfNotifications.length > 0 ? (
          historyOfNotifications.map((branchData, branchIndex) => (
            <React.Fragment key={branchIndex}>
              {branchData?.history && branchData.history.length > 0 ? (
                <>
                  {historyOfNotifications.length > 1 && (
                    <div style={{
                      fontSize: '18px',
                      fontWeight: 'bold',
                      marginTop: branchIndex > 0 ? '24px' : '0',
                      marginBottom: '12px'
                    }}>
                      {branchData.branch_name || `Branch ID: ${branchData.branch_id}`}
                    </div>
                  )}
                  {[...branchData.history].reverse().map((historyItem, itemIndex) => (
                    <div key={`${branchIndex}-${itemIndex}`} className={styles.historyItem}>
                      <div className={styles.historyTop}>
                        <div>{format(new Date(historyItem.last_date), 'dd.MM.yyyy')}</div>
                      </div>
                      <div className={styles.historyCenter}>
                        {historyItem.message}
                      </div>
                      <div className={styles.historyBottom}>
                        <div>{historyItem.sent_count}</div>
                        {historyItem.completed_date ? (
                          <div>{format(new Date(historyItem.completed_date), 'dd.MM.yyyy')}</div>
                        ) : null}
                      </div>
                      <FailedNotificationLine item={historyItem} />
                    </div>
                  ))}
                </>
              ) : null}
            </React.Fragment>
          ))
        ) : (
          <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
            {t('NSClients.noHistory') || 'История пуста'}
          </div>
        )}
      </div>
    </div>
  )
}

export default XLSXNotifications